export default __webpack_public_path__ + "static/media/GraceVideoComp22.e3f89d48.mp4";